import EmptyRouterView from '@/components/common/EmptyRouterView'
import PrepressPlateOrders from '@/views/Prepress/PlateOrders/Index'
import PrepressJobs from '@/views/Prepress/Jobs/Index'

export default [
    {
        path: '',
        component: EmptyRouterView,
        meta: {
            title: 'Prepress',
            menuRendered: true,
            menuTitle: 'Prepress',
            icon: 'mdi-tray-full'
        },
        children: [
            {
                path: '/prepress/plate-orders',
                component: EmptyRouterView,
                meta: {
                    menuRendered: true,
                    menuTitle: 'Płyty dodatkowe',
                    permission: 'plate_orders',
                    requiresAuth: true,
                },
                children: [
                    {
                        path: '',
                        name: 'prepressPlateOrders',
                        component: PrepressPlateOrders,
                        meta: {
                            title: 'Prepress / Płyty dodatkowe',
                            requiresAuth: true,
                            permission: 'plate_orders',
                        },
                    }
                ]
            },
            {
                path: '/prepress/jobs',
                component: EmptyRouterView,
                meta: {
                    menuRendered: true,
                    menuTitle: 'Raportowanie zleceń',
                    permission: 'prepress_reports',
                    requiresAuth: true,
                },
                children: [
                    {
                        path: '',
                        name: 'prepressJobs',
                        component: PrepressJobs,
                        meta: {
                            title: 'Prepress / Raportowanie zleceń',
                            requiresAuth: true,
                            permission: 'prepress_reports',
                        },
                    }
                ]
            },
        ]
    },
]
